import Swiper from 'swiper';
import { EffectFade, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const containers = Array.from(document.querySelectorAll('.js-card-block'));

  containers.forEach((container) => {
    const wrapper = container.querySelector('.js-card-block-slider');
    const pagination = container.querySelector('.js-card-block-pagination');

    const cardBlockSlider = new Swiper(wrapper, {
      modules: [EffectFade, Pagination],
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: pagination,
      },
    });
  });
});
